// Inspired by https://github.com/payloadcms/payload/blob/main/packages/richtext-lexical/src/features/converters/lexicalToJSX/converter/converters/text.tsx
import React from "react";

const TextGenerator = {
	text: ({ node }) => {
		const text = node.text;

		return text;
	},
};

export default TextGenerator;
